<template>
  <div>
    <div style="margin-top: 15vh;margin-left: 16vw; width: 20vw; color: #fff;">
      <el-row :gutter="15" type="flex" justify="center">
        <el-form
          ref="resetForm"
          :model="formData"
          :rules="rules"
          size="medium"
          label-width="100px"
          class="formOutClass"
        >
          <el-col :span="24">
            <el-row>
              <el-col :span="24">
                <el-form-item label="原密码" prop="oldPasswd">
                  <el-input
                    v-model="formData.oldPasswd"
                    placeholder="请输入原密码"
                    clearable
                    prefix-icon="el-icon-key"
                    show-password
                    style="background-color: transparent;"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="新密码" prop="newPasswd">
                  <el-input
                    v-model="formData.newPasswd"
                    placeholder="请输入密码"
                    clearable
                    prefix-icon="el-icon-key"
                    show-password
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="确认新密码" prop="newPasswd2">
                  <el-input
                    v-model="formData.newPasswd2"
                    placeholder="请再次输入密码"
                    clearable
                    prefix-icon="el-icon-key"
                    show-password
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item size="large">
                  <el-button @click="resetForm">重置</el-button>
                  <el-button type="primary" @click="submitForm">提交</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-form>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.formData.newPasswd) {
        callback(new Error('两次输入新密码不一致'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      formData: {
        oldPasswd: '',
        newPasswd: '',
        newPasswd2: ''
      },
      rules: {
        oldPasswd: [
          {
            required: true,
            message: '请输入原密码',
            trigger: 'blur'
          }
        ],
        newPasswd: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          }
        ],
        newPasswd2: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    resetForm () {
      this.$nextTick(() => {
        // 不加这一行会报未定义的错误
        this.$refs.resetForm.resetFields()
      })
    },
    onClose () {
      this.dialogVisible = false
    },
    submitForm () {
      this.$refs.resetForm.validate(valid => {
        if (valid) {
          this.doSubmitForm() // 正式提交表单
        }
      })
    },
    doSubmitForm () {
      const api = '/md/front/user/resetPassword'
      const params = this.formData
      delete params.newPasswd2 // 删除某一属性
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          // 注册成功
          this.$alert('重置成功', '提示')
        }
      })
    }
  }
}
</script>
<style scoped>

.formOutClass :deep(.el-input__inner){
  background-color: transparent;
}

</style>
